import { FunctionComponent } from "react";
import Image from "next/image";
import styled from "styled-components";

import { Device } from "@/utils/device";

const BreakBar: FunctionComponent = () => {
  return (
    <S.ImageContainer>
      <Image
        src="/images/marketing/about-page-breakbar.jpg"
        alt="Neon light reading sisterhood works"
        layout="fill"
        objectFit="cover"
      />
    </S.ImageContainer>
  );
};

const S = () => {};

S.ImageContainer = styled.div`
  margin: 2rem 0;
  height: 12rem;
  width: 100%;
  position: relative;

  @media (min-width: ${Device.desktop}) {
    height: 39.2rem;
    margin-top: 60px;
  }
`;

export default BreakBar;
